export default __webpack_public_path__ + "static/6-9b6dd6cc77def059f848de0f17600430.png";